import { SupportConfigurationFragment, SupportWidgetConfigurationFragment } from '@ocx/graphql';
import { SupportConfiguration, SupportWidgetEnabledConfiguration } from './support-configuration.types';

const mapSupportWidgetConfigurationFragmentToConfig = (
  fragment: SupportWidgetConfigurationFragment | null,
): SupportWidgetEnabledConfiguration | null => {
  if (!fragment?.enabled) {
    return null;
  }
  if (
    fragment.__typename === 'FreshdeskSupportWidgetConfiguration' &&
    fragment.enabled &&
    fragment.widgetId &&
    fragment.token &&
    fragment.host &&
    fragment.sdkUrl
  ) {
    return {
      enabled: true,
      type: 'freshdesk',
      widgetId: fragment.widgetId,
      token: fragment.token,
      host: fragment.host,
      sdkUrl: fragment.sdkUrl,
    };
  }
  if (fragment.__typename === 'DevRevSupportWidgetConfiguration' && fragment.enabled && fragment.appId) {
    return {
      enabled: true,
      type: 'devrev_plug',
      appId: fragment.appId,
    };
  }
  return null;
};

export const mapSupportConfigurationFragmentToConfig = (
  fragment: SupportConfigurationFragment,
): SupportConfiguration => {
  return {
    supportPhoneNumber: fragment.phoneNumber,
    supportTeamEmail: fragment.email,
    widget: fragment.widget ? mapSupportWidgetConfigurationFragmentToConfig(fragment.widget) : null,
  };
};
